import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

const MetroStationNode = memo(({ data, selected }) => {
  // Couleur de la famille (ou gris par défaut)
  const color = data.familyColor || '#555';

  return (
    <div style={{ position: 'relative', width: '30px', height: '30px' }}>
      {/* Handles invisibles */}
      <Handle type="target" position={Position.Left} style={{ opacity: 0 }} />

      {/* Cercle principal */}
      <div style={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        border: `5px solid ${selected ? '#000' : '#555'}`, // Devient noir si sélectionné
        boxShadow: selected ? `0 0 15px ${color}` : 'none', // Glow si sélectionné
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        zIndex: 20,
        position: 'absolute',
      }} />

      {/* Label */}
      <div style={{
        position: 'absolute',
        top: '-40px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '4px 10px',
        borderRadius: '12px',
        border: `1px solid ${selected ? color : 'transparent'}`,
        fontSize: '13px',
        fontWeight: '700',
        color: '#333',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        pointerEvents: 'none' // Le clic traverse le texte pour aller au noeud
      }}>
        {data.label}
      </div>

      <Handle type="source" position={Position.Right} style={{ opacity: 0 }} />
    </div>
  );
});

export default MetroStationNode;